import { connect } from 'react-redux';
import ConfirmPage from './confirm';
import { authCheck } from '../../../actions/login';

function mapsDispatchToProps(dispatch) {
	return {
		authCheck: () => dispatch(authCheck())
	};
}

export default connect(() => ({}), mapsDispatchToProps)(ConfirmPage);